import { Text, StyleSheet, View, ViewStyle, StyleProp, TextStyle, Pressable } from 'react-native';
import { color_999999, color_main, white } from '../assets/style/colors';
import CheckBox from '@react-native-community/checkbox';

type CheckBoxViewProps = {
	value?: boolean;
	style?: ViewStyle;
	disabled?: boolean;
	onValueChange?: (value: boolean) => void;
};
export const CheckBoxView = ({ style, value, disabled, onValueChange }: CheckBoxViewProps) => {
	return (
		<CheckBox
			disabled={disabled === true}
			value={value}
			style={style}
			onValueChange={onValueChange}
			onFillColor={color_main}
			onCheckColor={white}
			tintColor="#aaa"
			onTintColor={color_main}
			tintColors={{ true: color_main, false: '#aaa' }}
		/>
	);
};
